import { Component, OnInit, ChangeDetectorRef, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource } from '@angular/material/table';
import { DashboardService } from './dashboard.service';
import { FormService } from "../form/form.service";
import { SharedService } from "../services/shared.service";
import { S3Service } from '../services/s3.service';
import { MatSort } from '@angular/material/sort';
import * as _ from 'lodash';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FilterService } from '../services/filter.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import clonedeep from 'lodash.clonedeep';
import { MatDialog } from '@angular/material/dialog';
import { CcEmailAndSmsComponent } from "./cc-email-and-sms/cc-email-and-sms.component";
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as moment from 'moment-timezone';
export interface PeriodicElement {
	name: string;
	sortTime: string;
	sortSenders: string;
	sortForms: string;
	sortTopics: string;
	subTopics: string;
}

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent implements OnInit, OnDestroy {

	@ViewChild(MatSort) sort: MatSort;
	// displayedColumns =
	// 	['select', 'name', 'sortForms', 'sortTopics', 'subTopics', 'sortSenders', 'sortTime', 'star'];
	displayedColumns = [];
	submittedForms: any = [];
	selection = new SelectionModel<PeriodicElement>(true, []);
	formsToDrag = [];
	showDragDiv: boolean = false;
	formsChecked: boolean = false;
	sortForms = ["All Forms"];
	sortTopics = ["All Topics"];
	sortSubTopics = ["All Sub Topics"];
	sortSenders = ["All Senders"];
	flaggedFilter = false;
	actionTypes;
	importantTypeId;
	viewSortFilter: boolean = false;
	actionTypeName: string = "";
	actionTypeBoard: boolean = false;
	displayNoRecords: boolean = false;
	bgTextColor = "#000000";
	filteredTopic = "";
	filteredSubtopic = "";
	filteredSenders = "";
	filteredForm = "";
	tableDataSource = [];
	filteredElements = [];
	actionTypeId;
	page = 0;
	pageSize = 50;
	stopFetching = false;
	allDataLoaded = false;
	allForms: any = []
	allFilters: any = []
	yellow_cricle = { "v": "5.6.5", "fr": 60, "ip": 0, "op": 30, "w": 1500, "h": 1500, "nm": "3", "ddd": 0, "assets": [{ "id": "comp_0", "layers": [{ "ddd": 0, "ind": 1, "ty": 4, "nm": "mask_Shape_gray 2", "td": 1, "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [776, 752, 0], "ix": 2 }, "a": { "a": 0, "k": [26, 2, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "a": 0, "k": [1412, 1412], "ix": 2 }, "p": { "a": 0, "k": [0, 0], "ix": 3 }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 0, "ix": 5 }, "lc": 1, "lj": 1, "ml": 4, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "fl", "c": { "a": 0, "k": [0.322952719296, 0.338910450655, 0.549019607843, 1], "ix": 4 }, "o": { "a": 0, "k": 100, "ix": 5 }, "r": 1, "bm": 0, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [0, 4], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }], "ip": 0, "op": 601, "st": 0, "bm": 0 }, { "ddd": 0, "ind": 2, "ty": 4, "nm": "orange_moving", "tt": 1, "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 1, "k": [{ "i": { "x": 0.273, "y": 1 }, "o": { "x": 0.589, "y": 0 }, "t": 38, "s": [2727.669, 2320.391, 0], "to": [-1707.16, -378.773, 0], "ti": [0, 0, 0] }, { "t": 195, "s": [-58.171, 766.231, 0] }], "ix": 2 }, "a": { "a": 0, "k": [0, 180, 0], "ix": 1 }, "s": { "a": 0, "k": [434.46, 268, 100], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [-19.56, 7.86], [-20.16, -6.12], [-17.22, -9.78], [-9.36, -3.12], [-9.84, 0.78], [-8.94, 4.26], [-8.4, 5.22], [-9.06, 3.84], [-9.9, -0.18], [-9, -4.14], [-8.34, -5.28], [-9, -4.08], [-9.9, 0], [-9, 4.02], [-8.34, 5.28], [-9, 4.14], [-9.9, 0.18], [-9.06, -3.84], [-8.4, -5.16], [-8.88, -4.32], [-9.84, -0.78], [-9.42, 3.12], [-8.58, 4.86], [-18.96, 5.7], [-19.56, -7.8], [-10.44, -18.36], [0, 0], [0, 0]], "o": [[10.38, -18.36], [19.56, -7.8], [18.96, 5.7], [8.58, 4.86], [9.42, 3.12], [9.9, -0.78], [8.88, -4.32], [8.4, -5.16], [9.12, -3.84], [9.84, 0.18], [8.94, 4.14], [8.34, 5.28], [9.06, 4.02], [9.9, 0], [9.06, -4.08], [8.34, -5.28], [9, -4.14], [9.9, -0.18], [9.12, 3.84], [8.34, 5.22], [8.88, 4.26], [9.9, 0.78], [9.36, -3.12], [17.16, -9.78], [20.16, -6.12], [19.56, 7.86], [0, 0], [0, 0], [0, 0]], "v": [[-434.7, -96.808], [-387.96, -137.608], [-326.04, -140.308], [-273.36, -113.369], [-246.54, -100.889], [-217.38, -96.808], [-189.06, -105.088], [-163.44, -119.969], [-137.46, -134.128], [-108.66, -140.308], [-80.1, -133.048], [-54.42, -118.288], [-28.68, -103.648], [0, -96.808], [28.62, -103.648], [54.42, -118.288], [80.1, -133.048], [108.66, -140.308], [137.4, -134.128], [163.44, -119.969], [189.06, -105.088], [217.32, -96.808], [246.54, -100.889], [273.36, -113.369], [326.04, -140.308], [387.96, -137.608], [434.7, -96.808], [434.7, 504.272], [-434.7, 504.272]], "c": true }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "fl", "c": { "a": 0, "k": [0.937254961799, 0.658823529412, 0.352941176471, 1], "ix": 4 }, "o": { "a": 0, "k": 100, "ix": 5 }, "r": 1, "bm": 0, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [0, 0], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }], "ip": 0, "op": 602, "st": 0, "bm": 0 }, { "ddd": 0, "ind": 3, "ty": 4, "nm": "mask_Shape_gray 3", "td": 1, "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [776, 752, 0], "ix": 2 }, "a": { "a": 0, "k": [26, 2, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "a": 0, "k": [1412, 1412], "ix": 2 }, "p": { "a": 0, "k": [0, 0], "ix": 3 }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 0, "ix": 5 }, "lc": 1, "lj": 1, "ml": 4, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "fl", "c": { "a": 0, "k": [0.322952719296, 0.338910450655, 0.549019607843, 1], "ix": 4 }, "o": { "a": 0, "k": 100, "ix": 5 }, "r": 1, "bm": 0, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [0, 4], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }], "ip": 0, "op": 601, "st": 0, "bm": 0 }, { "ddd": 0, "ind": 4, "ty": 4, "nm": "blue_moving 2", "tt": 1, "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 1, "k": [{ "i": { "x": 0.273, "y": 1 }, "o": { "x": 0.589, "y": 0 }, "t": 38, "s": [-1352.331, 2232.391, 0], "to": [1724.84, -450.773, 0], "ti": [0, 0, 0] }, { "t": 195, "s": [1589.829, 758.231, 0] }], "ix": 2 }, "a": { "a": 0, "k": [0, 180, 0], "ix": 1 }, "s": { "a": 0, "k": [434.46, 268, 100], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "ind": 0, "ty": "sh", "ix": 1, "ks": { "a": 0, "k": { "i": [[0, 0], [-19.56, 7.86], [-20.16, -6.12], [-17.22, -9.78], [-9.36, -3.12], [-9.84, 0.78], [-8.94, 4.26], [-8.4, 5.22], [-9.06, 3.84], [-9.9, -0.18], [-9, -4.14], [-8.34, -5.28], [-9, -4.08], [-9.9, 0], [-9, 4.02], [-8.34, 5.28], [-9, 4.14], [-9.9, 0.18], [-9.06, -3.84], [-8.4, -5.16], [-8.88, -4.32], [-9.84, -0.78], [-9.42, 3.12], [-8.58, 4.86], [-18.96, 5.7], [-19.56, -7.8], [-10.44, -18.36], [0, 0], [0, 0]], "o": [[10.38, -18.36], [19.56, -7.8], [18.96, 5.7], [8.58, 4.86], [9.42, 3.12], [9.9, -0.78], [8.88, -4.32], [8.4, -5.16], [9.12, -3.84], [9.84, 0.18], [8.94, 4.14], [8.34, 5.28], [9.06, 4.02], [9.9, 0], [9.06, -4.08], [8.34, -5.28], [9, -4.14], [9.9, -0.18], [9.12, 3.84], [8.34, 5.22], [8.88, 4.26], [9.9, 0.78], [9.36, -3.12], [17.16, -9.78], [20.16, -6.12], [19.56, 7.86], [0, 0], [0, 0], [0, 0]], "v": [[-434.7, -96.808], [-387.96, -137.608], [-326.04, -140.308], [-273.36, -113.369], [-246.54, -100.889], [-217.38, -96.808], [-189.06, -105.088], [-163.44, -119.969], [-137.46, -134.128], [-108.66, -140.308], [-80.1, -133.048], [-54.42, -118.288], [-28.68, -103.648], [0, -96.808], [28.62, -103.648], [54.42, -118.288], [80.1, -133.048], [108.66, -140.308], [137.4, -134.128], [163.44, -119.969], [189.06, -105.088], [217.32, -96.808], [246.54, -100.889], [273.36, -113.369], [326.04, -140.308], [387.96, -137.608], [434.7, -96.808], [434.7, 504.272], [-434.7, 504.272]], "c": true }, "ix": 2 }, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false }, { "ty": "fl", "c": { "a": 0, "k": [0.160784313725, 0.462745098039, 0.713725490196, 1], "ix": 4 }, "o": { "a": 0, "k": 100, "ix": 5 }, "r": 1, "bm": 0, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [0, 0], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Group 1", "np": 2, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }], "ip": 0, "op": 602, "st": 0, "bm": 0 }, { "ddd": 0, "ind": 5, "ty": 4, "nm": "Shape_gray", "sr": 1, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [776, 752, 0], "ix": 2 }, "a": { "a": 0, "k": [26, 2, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "shapes": [{ "ty": "gr", "it": [{ "d": 1, "ty": "el", "s": { "a": 0, "k": [1412, 1412], "ix": 2 }, "p": { "a": 0, "k": [0, 0], "ix": 3 }, "nm": "Ellipse Path 1", "mn": "ADBE Vector Shape - Ellipse", "hd": false }, { "ty": "st", "c": { "a": 0, "k": [0, 0, 0, 1], "ix": 3 }, "o": { "a": 0, "k": 100, "ix": 4 }, "w": { "a": 0, "k": 0, "ix": 5 }, "lc": 1, "lj": 1, "ml": 4, "bm": 0, "nm": "Stroke 1", "mn": "ADBE Vector Graphic - Stroke", "hd": false }, { "ty": "fl", "c": { "a": 0, "k": [0.945098039216, 0.937254901961, 0.937254901961, 1], "ix": 4 }, "o": { "a": 0, "k": 100, "ix": 5 }, "r": 1, "bm": 0, "nm": "Fill 1", "mn": "ADBE Vector Graphic - Fill", "hd": false }, { "ty": "tr", "p": { "a": 0, "k": [0, 4], "ix": 2 }, "a": { "a": 0, "k": [0, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100], "ix": 3 }, "r": { "a": 0, "k": 0, "ix": 6 }, "o": { "a": 0, "k": 100, "ix": 7 }, "sk": { "a": 0, "k": 0, "ix": 4 }, "sa": { "a": 0, "k": 0, "ix": 5 }, "nm": "Transform" }], "nm": "Ellipse 1", "np": 3, "cix": 2, "bm": 0, "ix": 1, "mn": "ADBE Vector Group", "hd": false }], "ip": 0, "op": 601, "st": 0, "bm": 0 }] }], "layers": [{ "ddd": 0, "ind": 1, "ty": 0, "nm": "option_2", "refId": "comp_0", "sr": 0.26, "ks": { "o": { "a": 0, "k": 100, "ix": 11 }, "r": { "a": 0, "k": 0, "ix": 10 }, "p": { "a": 0, "k": [750, 750, 0], "ix": 2 }, "a": { "a": 0, "k": [750, 750, 0], "ix": 1 }, "s": { "a": 0, "k": [100, 100, 100], "ix": 6 } }, "ao": 0, "w": 1500, "h": 1500, "ip": 0, "op": 31, "st": -13.7703703703704, "bm": 0 }], "markers": [] }
	filters: any = {
		topic: "",
		subtopic: "",
		name: "",
		submittedBy: "",
		is_flagged: "",
		helpFormId: environment.help_form_id
	}
	imageRequests = []
	resetSelctedFormsEvent: Subscription;
	userPriveleges = [];
	timezone;

	constructor(
		private _dashboardService: DashboardService,
		private _router: Router,
		private activatedRoute: ActivatedRoute,
		private _sharedService: SharedService,
		private _formService: FormService,
		private _changeDetectionRef: ChangeDetectorRef,
		private _s3Service: S3Service,
		private _snackBar: MatSnackBar,
		public dialog: MatDialog,
		private _filterService: FilterService
	) {
		this._sharedService.searchChange.subscribe(value => {
			this.submittedForms.filter = value.toLowerCase();
			if (this.submittedForms.filteredData.length === 0) {
				this.displayNoRecords = true;
			} else {
				this.displayNoRecords = false;
			}
			this.updateFiltersForSearch();
		});

		this.resetSelctedFormsEvent = this._dashboardService.recieveResetSelectedFormsEvent().subscribe(() => {
			this.resetSelectedForms();
		})

		this._dashboardService.invokeEvent.subscribe(forms => {
			this.refreshFormsList(forms);
		});
	}

	ngOnInit(): void {
		this.timezone = localStorage.getItem('timezone');
		this.page = 0;
		this.allForms = []
		this.formsToDrag = []
		this.onInit();
		window.name = "sort-home";
		let bgTextColor = localStorage.getItem('bgTextColor');
		if (bgTextColor && bgTextColor.length > 0) {
			bgTextColor = bgTextColor.substring(1);
		}
	}

	ngOnDestroy(): void {
		if (this.imageRequests && this.imageRequests.length) {
			this.imageRequests.forEach(request => {
				request.unsubscribe()
			})
		}
	}

	check(hex) {
		if (/[0-9A-F]{6}$/i.test(hex)) {
			return true;
		}
	}

	updateHomeColor(hex) {
		const filterChildren = document.getElementById('sort_form_icon_10_width')["children"];
		for (let i = 0; i < filterChildren.length; i++) {
			filterChildren[i]["style"]["stroke"] = this.bgTextColor;
		}
	}

	isAllSelected(): boolean {
		const numSelected = this.selection.selected.length;
		const numRows = this.submittedForms?.data?.length || 0;
		return numSelected === numRows && numRows > 0;
	}

	masterToggle(checked: boolean): void {
		this.formsChecked = true;
		if (!this.submittedForms?.data?.length) return;

		if (checked) {
			// Select all
			this.submittedForms.data.forEach((row) => {
				this.selection.select(row)
				this.formsToDrag.push(row._id);
				const tableElement = document.getElementById(row._id);
				tableElement.setAttribute("draggable", "true"); // Setting draggable attribute true when selected
			});
		} else {
			// Unselect all
			this.selection.clear();
			this.formsToDrag = [];
			this.submittedForms.data.forEach((row) => {
				const tableElement = document.getElementById(row._id);
				tableElement.setAttribute("draggable", "false"); // Setting draggable attribute true when selected
			});
		}
	}

	checkboxLabel(row?: PeriodicElement): string {
		if (!row) {
			return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
		}
		return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.name + 1}`;
	}

	onInit(): void {
		let searchInput = document.getElementById("searchInput");
		if (localStorage.getItem('bgTextColor')) this.bgTextColor = localStorage.getItem("bgTextColor");
		if (searchInput) searchInput["value"] = "";
		// this.sortTopics = ["All Topics"];
		// this.sortSubTopics = ["All Sub Topics"];
		// this.sortSenders = ["All Senders"];
		// this.sortForms = ["All Forms"];
		// this.filteredForm = "";
		// this.filteredTopic = "";
		// this.filteredSubtopic = "";
		// this.filteredSenders = "";
		this._sharedService.getPrivileges(localStorage.getItem('role')).subscribe((response) => {
			if (response['success']) {
				this.userPriveleges = response['data'][0]['privileges'];
			}
			this.filteredElements = [];
			this.displayNoRecords = false;
			// this.formsToDrag = [];
			this._formService.getActionTypes(localStorage.getItem('organization')).subscribe((result) => {
				this.actionTypes = result;
				if (result["success"]) {
					this.actionTypes = result["data"];
					let actionTypes = result["data"];
					actionTypes.forEach((actionType) => {
						if (actionType.name === "Important") {
							this.importantTypeId = actionType._id;
						}
					});
				}
			});

			this.activatedRoute.paramMap.subscribe(params => {

				if (params.get('actionType')) {
					this.actionTypeId = params.get('actionType');
					this.sortTopics = ["All Topics"];
					this.sortSubTopics = ["All Sub Topics"];
					this.sortSenders = ["All Senders"];
					this.sortForms = ["All Forms"];
					this.submittedForms = [];
					this.displayedColumns = ['select', 'sortTopics', 'subTopics', 'name', 'sortSenders', 'sortForms', 'sortTime', 'star'];
					this.viewSortFilter = false;
					this.actionTypeBoard = true;
					this.filteredForm = "";
					this.filteredTopic = "";
					this.filteredSubtopic = "";
					this.filteredSenders = "";
					this.filteredElements = [];
					this.actionTypeName = localStorage.getItem('actionType');
					if (this.checkPrivilege("help_forms")) {
						this._dashboardService.getSubmittedFormsOfActionType(localStorage.getItem('organization'), params.get('actionType'), JSON.stringify({ isHelpAdmin: true })).subscribe((response) => {
							if (response['success']) {
								if (response['data']['documents'] && response['data']['documents'].length > 0) {
									let submittedForms = response['data']['documents'];
									let sortOrder = response["data"]["sort"];
									if (submittedForms.length > 0) {
										_.map(submittedForms, (element) => {
											element.isImportant = false;
											sortOrder.forEach((sort) => {
												if (sort.id === element._id) {
													element.order = sort.order;
												}
											});
										});
										submittedForms.forEach((form) => {
											let actionTypes = form["actionTypes"];
											if (actionTypes && actionTypes.length > 0) {
												actionTypes.forEach((actionType) => {
													if (actionType === this.importantTypeId) {
														form.isImportant = true;
													}
												});
											}
											if (this.timezone) {
												form['sortTime'] = moment(form['sortTime']).tz(this.timezone).format('llll')
											}
											form["sortTopics"] = form["sortTopics"] ? (_.isString(form["sortTopics"]) ? form["sortTopics"] : Object.values(form["sortTopics"])[0]) : '';
											form["subTopics"] = form["subTopics"] ? (_.isString(form["subTopics"]) ? form["subTopics"] : Object.values(form["subTopics"])[0]) : '';

											if (!_.includes(this.sortForms, form.sortForms)) {
												this.sortForms.push(form.sortForms);
											}

											if (!_.includes(this.sortTopics, form["sortTopics"])) {
												if (form["sortTopics"] && form["sortTopics"].length !== 0) {
													this.sortTopics.push(form["sortTopics"])
												}
											}

											if (!_.includes(this.sortSubTopics, form["subTopics"])) {
												if (form["subTopics"] && form["subTopics"].length !== 0) {
													this.sortSubTopics.push(form["subTopics"]);
												}
											}

											if (!_.includes(this.sortSenders, form["sortSenders"])) {
												if (form["sortSenders"] && form["sortSenders"].length !== 0) {
													this.sortSenders.push(form["sortSenders"]);
												}
											}
											// Fetching images
											let template_schema = form["template"]["template_schema"]["schema"];
											let response = form["response"];

											template_schema.forEach((element) => {
												for (let i = 0; i < Object.keys(response).length; i++) {
													if (response[element.key] !== undefined) {
														element["value"] = response[element.key];
													}
												}

												if (element.type === 'picture') {
													if (element["value"] && element["value"].length > 0) {
														element["value"] = element["value"].filter((v, i, a) => a.indexOf(v) === i);
														form["raw_images"] = [];
														for (let j = 0; j < element["value"].length; j++) {
															if (j === 2) {
																break;
															}
															let request = this._s3Service.getObjectFromKey(element["value"][j]).subscribe((response) => {
																if (response && response["data"] && Object.keys(response["data"]).length > 0) {
																	var binary = '';
																	var bytes = new Uint16Array(response['data']);
																	var len = bytes.byteLength;
																	for (var i = 0; i < len; i++) {
																		binary += String.fromCharCode(bytes[i]);
																	}
																	let image = "data:image/jpeg;base64," + window.btoa(binary);
																	if (form["raw_images"].length < 2) {
																		form["raw_images"].push({ src: image });
																	}
																}
															}, (error) => {
																console.log(error);
															});

															this.imageRequests.push(request)
														}
													}
												} else if (element.type === 'file') {
													if (element.value && element.value.length > 0) {
														form["file_exists"] = true;
													} else {
														form["file_exists"] = false;
													}
												}
											});
										});
										submittedForms.sort((a, b) => {
											return a.order - b.order;
										});
										this.allForms = submittedForms;
										this.allDataLoaded = true;
										this.submittedForms = new MatTableDataSource(submittedForms);
										this.submittedForms.sort = this.sort;
										this._dashboardService.refreshCount([]);
										this.tableDataSource = submittedForms;
										this.sortFilters()
									}
								} else {
									this.submittedForms = [];
									this.sortTopics = [];
									this.sortSubTopics = [];
									this.sortSenders = [];
									this.sortForms = [];
									this.sortFilters()
								}
							}
						}, (error) => {
							console.log(error);
						});
					} else {
						this._dashboardService.getSubmittedFormsOfActionType(localStorage.getItem('organization'), params.get('actionType')).subscribe((response) => {
							if (response['success']) {
								if (response['data']['documents'] && response['data']['documents'].length > 0) {
									let submittedForms = response['data']['documents'];
									let sortOrder = response["data"]["sort"];
									if (submittedForms.length > 0) {
										_.map(submittedForms, (element) => {
											element.isImportant = false;
											sortOrder.forEach((sort) => {
												if (sort.id === element._id) {
													element.order = sort.order;
												}
											});
										});
										submittedForms.forEach((form) => {
											let actionTypes = form["actionTypes"];
											if (actionTypes && actionTypes.length > 0) {
												actionTypes.forEach((actionType) => {
													if (actionType === this.importantTypeId) {
														form.isImportant = true;
													}
												});
											}
											if (this.timezone) {
												form['sortTime'] = moment(form['sortTime']).tz(this.timezone).format('llll')
											}
											form["sortTopics"] = form["sortTopics"] ? (_.isString(form["sortTopics"]) ? form["sortTopics"] : Object.values(form["sortTopics"])[0]) : '';
											form["subTopics"] = form["subTopics"] ? (_.isString(form["subTopics"]) ? form["subTopics"] : Object.values(form["subTopics"])[0]) : '';

											if (!_.includes(this.sortForms, form.sortForms)) {
												this.sortForms.push(form.sortForms);
											}

											if (!_.includes(this.sortTopics, form["sortTopics"])) {
												if (form["sortTopics"] && form["sortTopics"].length !== 0) {
													this.sortTopics.push(form["sortTopics"])
												}
											}

											if (!_.includes(this.sortSubTopics, form["subTopics"])) {
												if (form["subTopics"] && form["subTopics"].length !== 0) {
													this.sortSubTopics.push(form["subTopics"]);
												}
											}

											if (!_.includes(this.sortSenders, form["sortSenders"])) {
												if (form["sortSenders"] && form["sortSenders"].length !== 0) {
													this.sortSenders.push(form["sortSenders"]);
												}
											}
											// Fetching images
											let template_schema = form["template"]["template_schema"]["schema"];
											let response = form["response"];

											template_schema.forEach((element) => {
												for (let i = 0; i < Object.keys(response).length; i++) {
													if (response[element.key] !== undefined) {
														element["value"] = response[element.key];
													}
												}

												if (element.type === 'picture') {
													if (element["value"] && element["value"].length > 0) {
														element["value"] = element["value"].filter((v, i, a) => a.indexOf(v) === i);
														form["raw_images"] = [];
														for (let j = 0; j < element["value"].length; j++) {
															if (j === 2) {
																break;
															}
															let request = this._s3Service.getObjectFromKey(element["value"][j]).subscribe((response) => {
																if (response && response["data"] && Object.keys(response["data"]).length > 0) {
																	var binary = '';
																	var bytes = new Uint16Array(response['data']);
																	var len = bytes.byteLength;
																	for (var i = 0; i < len; i++) {
																		binary += String.fromCharCode(bytes[i]);
																	}
																	let image = "data:image/jpeg;base64," + window.btoa(binary);
																	if (form["raw_images"].length < 2) {
																		form["raw_images"].push({ src: image });
																	}
																}
															}, (error) => {
																console.log(error);
															});

															this.imageRequests.push(request)
														}
													}
												} else if (element.type === 'file') {
													if (element.value && element.value.length > 0) {
														form["file_exists"] = true;
													} else {
														form["file_exists"] = false;
													}
												}
											});
										});
										submittedForms.sort((a, b) => {
											return a.order - b.order;
										});
										this.allForms = submittedForms;
										this.allDataLoaded = true;
										this.submittedForms = new MatTableDataSource(submittedForms);
										this.submittedForms.sort = this.sort;
										this._dashboardService.refreshCount([]);
										this.tableDataSource = submittedForms;
										this.sortFilters()
									}
								} else {
									this.submittedForms = [];
									this.sortTopics = [];
									this.sortSubTopics = [];
									this.sortSenders = [];
									this.sortForms = [];
									this.sortFilters()
								}
							}
						}, (error) => {
							console.log(error);
						});
					}
				} else {
					// this.submittedForms = [];
					// this.sortTopics = ["All Topics"];
					// this.sortSubTopics = ["All Sub Topics"];
					// this.sortSenders = ["All Senders"];
					// this.sortForms = ["All Forms"]
					// this.filteredForm = "";
					// this.filteredTopic = "";
					// this.filteredSubtopic = "";
					// this.filteredSenders = "";
					// Only fetch all filters on initial load (when no filters are applied)
					if (!this.hasActiveFilters()) {
						this.getFilters();
					}

					this.filteredElements = [];
					this.displayedColumns = ['select', 'sortTopics', 'subTopics', 'name', 'sortSenders', 'sortForms', 'sortTime', 'star'];
					this.viewSortFilter = true;
					this.actionTypeBoard = false;
					this.actionTypeName = "";
					if (!this.checkPrivilege("help_forms")) {
						delete this.filters.helpFormId
					}
					this._dashboardService.getSubmittedForms(localStorage.getItem('organization'), this.page, this.pageSize, this.filters).subscribe((response) => {
						if (response['success']) {
							if (response['data'].length > 0) {
								this.submittedForms = [];
								let submittedForms = response['data'];
								if (submittedForms.length < this.pageSize) {
									this.stopFetching = true;
									// Only set allDataLoaded if no filters are active
									if (!this.hasActiveFilters()) {
										this.allDataLoaded = true;
									}
								}
								if (submittedForms.length > 0) {
									submittedForms.forEach((form) => {
										let actionTypes = form["actionTypes"];
										form["checked"] = false;
										if (actionTypes && actionTypes.length > 0) {
											actionTypes.forEach((actionType) => {
												if (actionType === this.importantTypeId) {
													form.isImportant = true;
												}
											});
										}
										if (this.timezone) {
											form['sortTime'] = moment(form['sortTime']).tz(this.timezone).format('llll')
										}
										form["sortTopics"] = form["sortTopics"] ? (_.isString(form["sortTopics"]) ? form["sortTopics"] : Object.values(form["sortTopics"])[0]) : '';
										form["subTopics"] = form["subTopics"] ? (_.isString(form["subTopics"]) ? form["subTopics"] : Object.values(form["subTopics"])[0]) : '';

										// if (!_.includes(this.sortForms, form.sortForms)) {
										// 	this.sortForms.push(form.sortForms);
										// }

										// if (!_.includes(this.sortTopics, form["sortTopics"])) {
										// 	if (form["sortTopics"] && form["sortTopics"].length !== 0) {
										// 		this.sortTopics.push(form["sortTopics"])
										// 	}
										// }

										// if (!_.includes(this.sortSubTopics, form["subTopics"])) {
										// 	if (form["subTopics"] && form["subTopics"].length !== 0) {
										// 		this.sortSubTopics.push(form["subTopics"])
										// 	}
										// }

										// if (!_.includes(this.sortSenders, form["sortSenders"])) {
										// 	if (form["sortSenders"] && form["sortSenders"].length !== 0) {
										// 		this.sortSenders.push(form["sortSenders"]);
										// 	}
										// }

										// Fetching images
										let template_schema = form["template"]["template_schema"]["schema"];
										let response = form["response"];

										template_schema.forEach((element) => {
											if (response) {
												for (let i = 0; i < Object.keys(response).length; i++) {
													if (response[element.key] !== undefined) {
														element["value"] = response[element.key];
													}
												}
											}

											if (element.type === 'picture') {
												if (element["value"] && element["value"].length > 0) {
													element["value"] = element["value"].filter((v, i, a) => a.indexOf(v) === i);
													form["raw_images"] = [];
													for (let j = 0; j < element["value"].length; j++) {
														if (j === 2) {
															break;
														}
														let request = this._s3Service.getObjectFromKey(element["value"][j]).subscribe((response) => {
															if (response && response["data"] && Object.keys(response["data"]).length > 0) {
																var binary = '';
																var bytes = new Uint16Array(response['data']);
																var len = bytes.byteLength;
																for (var i = 0; i < len; i++) {
																	binary += String.fromCharCode(bytes[i]);
																}
																let image = "data:image/jpeg;base64," + window.btoa(binary);
																if (form["raw_images"].length < 2) {
																	form["raw_images"].push({ src: image });
																}
															}
														}, (error) => {
															console.log(error);
														});
														this.imageRequests.push(request)
													}
												}
											} else if (element.type === 'file') {
												if (element.value && element.value.length > 0) {
													form["file_exists"] = true;
												} else {
													form["file_exists"] = false;
												}
											}
										});
									});
									this.allForms.push(...submittedForms);
									this.submittedForms = new MatTableDataSource(this.allForms);
									this.submittedForms.sort = this.sort;
									this._dashboardService.refreshCount([]);
									this.tableDataSource = this.allForms;
									// Update filter dropdowns based on currently displayed data
									this.updateAvailableFilters();

								} else {
									this.sortTopics = ["All Topics"];
									this.sortSubTopics = ["All Sub Topics"];
									this.sortSenders = ["All Senders"];
									this.sortForms = ["All Forms"];
									this.updateAvailableFilters();
								}
							} else {
								this.submittedForms = new MatTableDataSource(this.allForms)
								this.stopFetching = true;
								// Only set allDataLoaded if no filters are active
								if (!this.hasActiveFilters()) {
									this.allDataLoaded = true;
								}
								this.submittedForms.sort = this.sort;
								this._dashboardService.refreshCount([]);
								this.tableDataSource = this.allForms;
								// Update filter dropdowns based on currently displayed data
								this.updateAvailableFilters();
							}
						}
					}, (error) => {
						console.log(error);
					});
				}
				// this.sortFilters();
			});
		});
	}

	ngAfterViewInit() {
		this.submittedForms.sort = this.sort;
	}

	ngAfterViewChecked() {
		if (this.check(this.bgTextColor)) {
			this._sharedService.updateHomeColor(this.bgTextColor);
		}
	}

	getFormDetails(formId) {
		if (this.actionTypeBoard) {
			this._router.navigateByUrl('/formDetails/' + localStorage.getItem('actionType') + "/" + formId);
		} else {
			this._router.navigateByUrl('/formDetails/' + formId);
		}
	}

	deleteSubmittedForm(formId, template) {
		// this._sharedService.confirmationDialog("Are you sure you want to delete the form?", () => {
		let requestData = {
			formId: formId,
			template: template
		};
		if (template == environment.help_form_id) {
			requestData['deleted_by'] = {
				username: localStorage.getItem('username'),
				user_id: localStorage.getItem('userId'),
				organization_id: localStorage.getItem('organization')
			}
		}

		this._dashboardService.deleteSubmittedForm(requestData).subscribe((response) => {
			if (response["success"]) {
				this.openSnackBar("Form deleted successfully");
				let submittedForms = this.submittedForms._data._value;
				let formIndex = submittedForms.findIndex((form) => form._id === formId);
				submittedForms.splice(formIndex, 1);
				this.updateFormsList(submittedForms);
				this._dashboardService.updateHeaderCounts.next();
			}
		}, (error) => {
			console.log(error);
		});
		// });
	}

	archiveSubmittedForm(formId, template) {
		// this._sharedService.confirmationDialog("Are you sure you want to archive the form?", () => {
		let requestData = {
			formId: formId,
			template: template
		};

		if (template == environment.help_form_id) {
			requestData['updated_by'] = {
				username: localStorage.getItem('username'),
				user_id: localStorage.getItem('userId'),
				organization_id: localStorage.getItem('organization')
			}
		}

		this._dashboardService.archiveSubmittedForm(requestData).subscribe((response) => {
			if (response["success"]) {
				this.openSnackBar("Form archived successfully");
				let submittedForms = this.submittedForms._data._value;
				let formIndex = submittedForms.findIndex((form) => form._id === formId);
				submittedForms.splice(formIndex, 1);
				this.updateFormsList(submittedForms);
				this._dashboardService.updateHeaderCounts.next();
			}
		}, (error) => {
			console.log(error);
		});
		// });
	}

	flagSubmittedForm(formId, is_flagged) {
		let requestData = {
			formId: formId
		};

		const index = this.submittedForms._data._value.findIndex(form => form._id === formId)
		if (is_flagged) {
			this.submittedForms._data._value[index]['is_flagged'] = false
			this._dashboardService.unflagSubmittedForm(requestData).subscribe((response) => {
				if (response["success"]) {
					// Nothing
				}
			}, (error) => {
				this.submittedForms._data._value[index]['is_flagged'] = is_flagged;
				this.openSnackBar("Server side error occurred. Please try again");
				console.log(error);
			});
		} else {
			this.submittedForms._data._value[index]['is_flagged'] = true

			this._dashboardService.flagSubmittedForm(requestData).subscribe((response) => {
				if (response["success"]) {
					// Nothing
				}
			}, (error) => {
				this.submittedForms._data._value[index]['is_flagged'] = is_flagged;
				this.openSnackBar("Server side error occurred. Please try again");
				console.log(error);
			});
		}

	}

	onReloadClick(): void {
		this.selection.clear();
		this.allForms = []
		this.stopFetching = false;
		this.allDataLoaded = false;
		this.resetFilters()
		this.ngOnInit();
	}

	markImportant(element) {
		this._formService.addActionTypeToForms({ ids: [element._id], actionType: this.importantTypeId }).subscribe((response) => {
			element.isImportant = true;
			this.onInit();
			this._changeDetectionRef.detectChanges();
		}, (error) => {
			console.log(error);
		});
	}

	unmarkImportant(element) {
		let requestData = {
			formId: element._id,
			actionTypeId: this.importantTypeId
		};
		this._formService.unmarkImportant(requestData).subscribe((response) => {
			if (response["success"]) {
				element.isImportant = false;
				this.onInit();
				this._changeDetectionRef.detectChanges();
			}
		})
	}

	onChecked(row: any, event): void {
		this.formsChecked = true;
		let tableElement = document.getElementById(row._id); // gettting table element by row id
		if (event.checked) {
			this.selection.select(row);
			tableElement.setAttribute("draggable", "true"); // Setting draggable attribute true when selected
			if (!this.formsToDrag.includes(row._id)) {
				this.formsToDrag.push(row._id);
			}
		} else {
			this.selection.deselect(row);
			let index = this.formsToDrag.indexOf(row._id);
			this.formsToDrag.splice(index, 1);
			tableElement.setAttribute("draggable", "false"); // Setting draggable attribute false when unselected
		}
	}

	onDragStart(event, row?): void {

		if (this.formsToDrag.length == 0) {
			// If only a single form is dragged
			let draggedForms = [row._id]
			var canvas = document.createElement('canvas');
			var context = canvas.getContext('2d');

			canvas.width = 200;
			canvas.height = 40;
			context.fillStyle = '#2d6cff';
			context.font = 'bold 14px Helvetica';
			context.fillRect(0, 0, canvas.width, canvas.height);
			context.fillStyle = '#ffffff';

			context.fillText('Copying ' + 1 + ' submission(s)', 25, 25);
			document.body.append(canvas);
			event.dataTransfer.effectAllowed = 'copy';
			event.dataTransfer.setDragImage(canvas, -15, 9);
			event.dataTransfer.setData(JSON.stringify(draggedForms), "");
			event.dataTransfer.dropEffect = 'move';
			event.dataTransfer.effectAllowed = 'move';
		} else {
			var canvas = document.createElement('canvas');
			var context = canvas.getContext('2d');

			canvas.width = 200;
			canvas.height = 40;
			context.fillStyle = '#2d6cff';
			context.font = 'bold 14px Helvetica';
			context.fillRect(0, 0, canvas.width, canvas.height);
			context.fillStyle = '#ffffff';

			let formsLength = this.selection.selected.length;
			context.fillText('Copying ' + formsLength + ' submission(s)', 25, 25);
			document.body.append(canvas);
			event.dataTransfer.effectAllowed = 'copy';
			event.dataTransfer.setDragImage(canvas, -15, 9);
			event.dataTransfer.setData(JSON.stringify(this.formsToDrag), "");
			event.dataTransfer.dropEffect = 'move';
			event.dataTransfer.effectAllowed = 'move';
		}
	}

	onDragEnd(): void {
		// this.onInit();
		// this.formsToDrag = []
	}

	filterForms(value): void {
		if (value === "All Forms") {
			this.filteredForm = "";
		} else {
			this.filteredForm = value;
		}

		this.applyFilters();
	}

	filterTopics(value): void {
		if (value === "All Topics") {
			this.filteredTopic = "";
		} else {
			this.filteredTopic = value;
		}

		this.applyFilters();
	}

	filterSubTopics(value): void {
		if (value == "All Sub Topics") {
			this.filteredSubtopic = "";
		} else {
			this.filteredSubtopic = value;
		}

		this.applyFilters();
	}

	filterSenders(value): void {
		if (value === "All Senders") {
			this.filteredSenders = "";
		} else {
			this.filteredSenders = value;
		}

		this.applyFilters();
	}

	filterFlaggedForms(value?): void {
		this.flaggedFilter = !this.flaggedFilter;

		if (value == "flagged") {
			this.filters.is_flagged = "true";
		} else {
			this.filters.is_flagged = "";
		}

		if (this.allDataLoaded) {
			this.applyFilters();
		} else {
			this.page = 0;
			this.allForms = [];
			this.stopFetching = false;
			this.ngOnDestroy();
			this.onInit();
		}
	}



	downloadPdfZip(): void {
		if (this.submittedForms.length === 0) {
			this.openSnackBar("No forms found");
			return;
		}
		let link = window.location.pathname.split("/");
		window.open("/download/pdf/" + localStorage.getItem('organization') + "/" + link[2]);
	}

	sendBulkSms(): void {
		if (this.submittedForms.length === 0) {
			this.openSnackBar("No forms found");
			return;
		}

		const dialogRef = this.dialog.open(CcEmailAndSmsComponent, {
			width: '400px',
			data: {
				type: "sms"
			}

		});
		dialogRef.afterClosed().subscribe((response) => {
			if (response["result"]) {
				let data = response["data"];
				if (data.length === 0) {
					this.openSnackBar("Please add numbers to send sms");
					return;
				}
				let link = window.location.pathname.split("/");
				let requestData = {
					organizationId: localStorage.getItem("organization"),
					actionTypeId: link[2],
					data: data
				}
				this._dashboardService.sendBulkSms(requestData).subscribe((response) => {
					if (response["success"]) {
						this.openSnackBar(response["message"]);
					}
				}, (error) => {
					console.log(error);
				});
			}
		});
	}

	sendBulkEmail(): void {

		if (this.submittedForms.length === 0) {
			this.openSnackBar("No forms found");
			return;
		}

		const dialogRef = this.dialog.open(CcEmailAndSmsComponent, {
			width: '400px',
			data: {
				type: "email"
			}
		});
		dialogRef.afterClosed().subscribe((response) => {
			if (response["result"]) {
				let data = response["data"];
				if (data.length === 0) {
					this.openSnackBar("Please add emails to send email");
					return;
				}
				let link = window.location.pathname.split("/");
				let requestData = {
					organizationId: localStorage.getItem("organization"),
					actionTypeId: link[2],
					data: data
				}
				this._dashboardService.sendBulkEmail(requestData).subscribe((response) => {
					if (response["success"]) {
						this.openSnackBar(response["message"]);
					}
				}, (error) => {
					console.log(error);
				});
			}
		});
	}

	openSnackBar(message) {
		this._snackBar.open(message, "Ok", {
			duration: 2000
		});
	}

	restoreArchivedItems() {
		let url = window.location.pathname.split("/");
		let requestData = {
			actionTypeId: url[2]
		};
		this._dashboardService.restoreArchivedForms(requestData).subscribe((response) => {
			if (response["success"]) {
				this.openSnackBar(response["message"]);
				this.onInit();
			} else {
				this.openSnackBar(response["message"]);
			}
		}, (error) => {
			console.log(error);
		});
	}

	deleteActionTypeForms() {
		// if (this.submittedForms.length === 0) {
		// 	this.openSnackBar("No forms found to delete");
		// 	return;
		// }
		this._sharedService.confirmationDialog("Are you sure you want to delete the List and forms in it?", () => {
			let url = window.location.pathname.split("/");
			let requestData = {
				actionTypeId: url[2]
			};
			this._dashboardService.deleteActionTypeForms(requestData).subscribe((response) => {
				if (response["success"]) {
					this.openSnackBar(response["message"]);
					// this.onInit();
					this._router.navigateByUrl('/dashboard');
				} else {
					this.openSnackBar(response["message"]);
				}
			}, (error) => {
				console.log(error);
			});
		});
	}

	archiveActionTypeForms() {
		// if (this.submittedForms.length === 0) {
		// 	this.openSnackBar("No forms found to archive");
		// 	return;
		// }
		this._sharedService.confirmationDialog("Are you sure you want to archive the List and forms in it?", () => {
			let url = window.location.pathname.split("/");
			let requestData = {
				actionTypeId: url[2]
			};
			this._dashboardService.archiveActionTypeForms(requestData).subscribe((response) => {
				if (response["success"]) {
					this._router.navigateByUrl('/dashboard');
					this.openSnackBar(response["message"]);
					this.onInit();
				} else {
					this.openSnackBar(response["message"]);
				}
			}, (error) => {
				console.log(error);
			});
		});
	}

	dropRow(event: CdkDragDrop<string[]>) {
		// Swap the elements around
		moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
		this.submittedForms.data = clonedeep(this.submittedForms.data);
		if (event.previousIndex !== event.currentIndex) {
			let order = 1;
			let requestData = {
				data: [],
				actionTypeId: this.actionTypeId
			}
			this.submittedForms.data.forEach((row) => {
				let obj = {
					id: row._id,
					order: order
				};
				order = order + 1;
				requestData.data.push(obj);
			});

			this._dashboardService.reorderActionType(requestData).subscribe((response) => {
				if (response["success"]) {
					this.openSnackBar(this.actionTypeName + " order updated");
				} else {
					this.openSnackBar(response["message"]);
				}
			}, (error) => {
				console.log(error);
				this.openSnackBar(error["message"]);
			});
		}
	}

	getArchivedForms() {
		let link = window.location.pathname.split("/");
		this._router.navigateByUrl('/dashboard/' + link[2] + "/restore");
	}

	navToHome() {
		localStorage.removeItem('actionType');
		this._router.navigate(["/dashboard"]);
	}

	navigateToExport() {
		this._router.navigateByUrl("/export-action-list/" + this.activatedRoute.snapshot.params['actionType']);
	}

	sortFilters() {
		this.sortTopics = this._filterService.sortFilterOptions(this.sortTopics, "All Topics");
		this.sortSubTopics = this._filterService.sortFilterOptions(this.sortSubTopics, "All Sub Topics");
		this.sortSenders = this._filterService.sortFilterOptions(this.sortSenders, "All Senders");
		this.sortForms = this._filterService.sortFilterOptions(this.sortForms, "All Forms");
	}

	updateFormsList(submittedForms) {
		this.sortForms = ["All Forms"];
		this.sortTopics = ["All Topics"];
		this.sortSubTopics = ["All Sub Topics"];
		this.sortSenders = ["All Senders"];
		if (submittedForms && submittedForms.length > 0) {
			submittedForms.forEach((form) => {
				form["checked"] = false;
				form["sortTopics"] = form["sortTopics"] ? (_.isString(form["sortTopics"]) ? form["sortTopics"] : Object.values(form["sortTopics"])[0]) : '';
				form["subTopics"] = form["subTopics"] ? (_.isString(form["subTopics"]) ? form["subTopics"] : Object.values(form["subTopics"])[0]) : '';

				if (!_.includes(this.sortForms, form.sortForms)) {
					this.sortForms.push(form.sortForms);
				}

				if (!_.includes(this.sortTopics, form["sortTopics"])) {
					if (form["sortTopics"].length !== 0) {
						this.sortTopics.push(form["sortTopics"])
					}
				}

				if (!_.includes(this.sortSubTopics, form["subTopics"])) {
					if (form["subTopics"].length !== 0) {
						this.sortSubTopics.push(form["subTopics"])
					}
				}

				if (!_.includes(this.sortSenders, form["sortSenders"])) {
					if (form["sortSenders"] && form["sortSenders"].length !== 0) {
						this.sortSenders.push(form["sortSenders"]);
					}
				}
			});

			this.submittedForms = new MatTableDataSource(submittedForms);
			this.submittedForms.sort = this.sort;
			// this._dashboardService.refreshCount([]);
			this.allForms = submittedForms
			this.tableDataSource = this.allForms;
		} else {
			this.submittedForms = [];
			this.tableDataSource = [];
		}
	}
	restoreIntoHome(formId) {
		let requestData = {
			data: [],
			actionTypeId: this.actionTypeId
		}
		let i = 1;
		this.submittedForms.data.forEach((row) => {
			if (formId != row._id) {
				let obj = {
					id: row._id,
					order: i++
				}
				requestData.data.push(obj);
			}
		})
		this._dashboardService.deleteFormInActionType(requestData).subscribe((response) => {
			if (response["success"]) {
				this.openSnackBar("List Updated successfully");
				let forms = this.submittedForms._data._value;
				let formIndex = forms.findIndex((form) => form._id === formId);
				forms.splice(formIndex, 1);
				this.updateFormsList(forms);
				this._dashboardService.updateHeaderCounts.next();
			} else {
				this.openSnackBar("Server side error occurred");
			}
		}, (error) => {
			console.log(error);
			this.openSnackBar(error["message"]);
		});
	}

	refreshFormsList(forms) {
		let submittedForms = this.submittedForms._data._value.filter((form) => {
			return (forms.indexOf(form._id) === -1)
		});
		this.updateFormsList(submittedForms);
	}

	onScroll(event) {
		let tablediv = document.getElementById("tablediv");
		event.preventDefault();
		event.stopImmediatePropagation()
		if (!this.stopFetching) {
			if (event.target.offsetHeight + Math.floor(event.target.scrollTop) >= (event.target.scrollHeight) && tablediv.scrollLeft == 0) {
				this.page++;
				this.onInit();
			}
		}
	}

	// Getting all filters
	getFilters() {
		this.sortTopics = ["All Topics"];
		this.sortSubTopics = ["All Sub Topics"];
		this.sortSenders = ["All Senders"];
		this.sortForms = ["All Forms"];
		// this.filteredForm = "";
		// this.filteredTopic = "";
		// this.filteredSubtopic = "";
		// this.filteredSenders = "";
		this._dashboardService.getFormFilters(localStorage.getItem('organization'), this.checkPrivilege("help_forms")).subscribe(response => {
			if (response['success']) {
				this.allFilters = response['data'];
				let filters = response['data'];
				filters.forEach(filter => {
					filter["topicKey"] = filter["topic"] ? (_.isString(filter["topic"]) ? filter["topic"] : Object.values(filter["topic"])[0]) : '';
					filter["subtopicKey"] = filter["subtopic"] ? (_.isString(filter["subtopic"]) ? filter["subtopic"] : Object.values(filter["subtopic"])[0]) : '';


					if (!_.includes(this.sortTopics, filter["topicKey"])) {
						if (filter["topicKey"] && filter["topicKey"].length !== 0) {
							this.sortTopics.push(filter["topicKey"])
						}
					}
					if (!_.includes(this.sortSubTopics, filter["subtopicKey"])) {
						if (filter["subtopicKey"] && filter["subtopicKey"].length !== 0) {
							this.sortSubTopics.push(filter["subtopicKey"])
						}
					}
					if (!_.includes(this.sortSenders, filter["submittedBy"])) {
						if (filter["submittedBy"] && filter["submittedBy"].length !== 0) {
							this.sortSenders.push(filter["submittedBy"])
						}
					}
					if (!_.includes(this.sortForms, filter["name"])) {
						if (filter["name"] && filter["name"].length !== 0) {
							this.sortForms.push(filter["name"])
						}
					}
				});
			}
			this.sortFilters()
		})
	}

	// Dashboard filters
	filterDashboardTopics(filter) {
		if (filter == "All Topics") {
			this.filters.topic = ""
			this.filteredTopic = "";
		} else {
			this.filters.topic = filter
			this.filteredTopic = filter;
		}

		if (this.allDataLoaded) {
			this.applyFilters();
		} else {
			this.page = 0;
			this.allForms = []
			this.stopFetching = false;
			this.ngOnDestroy()
			this.onInit()
		}
	}
	filterDashboardSubTopics(filter) {
		if (filter == "All Sub Topics") {
			this.filters.subtopic = ""
			this.filteredSubtopic = "";
		} else {
			this.filteredSubtopic = filter;
			this.filters.subtopic = filter
			for (const element of this.allFilters) {
				if (element['subtopic'] && typeof element["subtopic"] == "object" && Object.values(element["subtopic"])[0] == filter) {
					this.filters.subtopic = JSON.stringify(element['subtopic'])
					break
				}
			}
		}

		if (this.allDataLoaded) {
			this.applyFilters();
		} else {
			this.page = 0;
			this.allForms = []
			this.stopFetching = false;
			this.ngOnDestroy()
			this.onInit()
		}
	}
	filterDashboardSender(filter) {
		if (filter == "All Senders") {
			this.filteredSenders = "";
			this.filters.submittedBy = "";
		} else {
			this.filters.submittedBy = filter;
			this.filteredSenders = filter;
		}

		if (this.allDataLoaded) {
			this.applyFilters();
		} else {
			this.page = 0;
			this.allForms = []
			this.stopFetching = false;
			this.ngOnDestroy()
			this.onInit()
		}
	}
	filterDashboardForm(filter) {
		if (filter == "All Forms") {
			this.filters.name = "";
			this.filteredForm = "";
		} else {
			this.filters.name = filter;
			this.filteredForm = filter;
		}

		if (this.allDataLoaded) {
			this.applyFilters();
		} else {
			this.page = 0;
			this.allForms = []
			this.stopFetching = false;
			this.ngOnDestroy()
			this.onInit()
		}
	}

	resetSelectedForms() {
		this.formsToDrag = []
		this.formsChecked = false
		this.updateFormsList(this.allForms)
	}

	checkPrivilege(accessType) {
		return this._sharedService.checkPrivilege(this.userPriveleges, accessType);
	}

	resetFilters() {
		this.filters = {
			topic: "",
			subtopic: "",
			name: "",
			submittedBy: "",
			is_flagged: "",
			helpFormId: environment.help_form_id
		}
		this.filteredForm = "";
		this.filteredTopic = "";
		this.filteredSubtopic = "";
		this.filteredSenders = "";
	}


	// Check if any filter is active
	hasActiveFilters(): boolean {
		return this._filterService.hasActiveFilters({
			topic: this.filteredTopic,
			subtopic: this.filteredSubtopic,
			sender: this.filteredSenders,
			form: this.filteredForm
		});
	}

	// Clear individual filter
	clearFilter(type: string) {
		switch (type) {
			case 'topic':
				this.filters.topic = "";
				this.filteredTopic = "";
				break;
			case 'subtopic':
				this.filters.subtopic = "";
				this.filteredSubtopic = "";
				break;
			case 'sender':
				this.filters.submittedBy = "";
				this.filteredSenders = "";
				break;
			case 'form':
				this.filters.name = "";
				this.filteredForm = "";
				break;
		}

		if (this.allDataLoaded) {
			this.applyFilters();
		} else {
			this.page = 0;
			this.allForms = [];
			this.stopFetching = false;
			this.ngOnDestroy();
			this.onInit();
		}
	}

	// Centralized filter logic for Dashboard (Additive & Faceted)
	applyFilters() {
		// Clear selection state when filtering
		this.selection.clear();
		this.formsToDrag = [];
		this.formsChecked = false;

		const source = this.allDataLoaded ? this.allForms : this.tableDataSource;

		const filters = {
			topic: this.filteredTopic,
			subtopic: this.filteredSubtopic,
			sender: this.filteredSenders,
			form: this.filteredForm
		};
		const isFlagged = this.filters.is_flagged === "true";

		const filteredData = this._filterService.applyFilters(source, filters, isFlagged);

		this.submittedForms = new MatTableDataSource(filteredData);
		this.submittedForms.sort = this.sort;
		this.updateFilterLists();
		this._changeDetectionRef.detectChanges();
	}

	// Dynamic update of dropdown lists (faceted search)
	updateFilterLists() {
		const allData = this.allDataLoaded ? this.allForms : this.tableDataSource;

		const filters = {
			topic: this.filteredTopic,
			subtopic: this.filteredSubtopic,
			sender: this.filteredSenders,
			form: this.filteredForm
		};

		const options = this._filterService.getFilterOptions(allData, filters);
		this.sortTopics = options.topics;
		this.sortSubTopics = options.subTopics;
		this.sortSenders = options.senders;
		this.sortForms = options.forms;

		this.sortFilters();
	}

	// Legacy support for other parts of the dashboard
	applyClientSideFilters() {
		this.applyFilters();
	}

	updateAvailableFilters() {
		this.updateFilterLists();
	}

	// Update filters based on search results
	updateFiltersForSearch() {
		const searchText = this._sharedService.searchText;
		const options = this._filterService.updateFiltersForSearch(this.submittedForms, searchText);
		this.sortTopics = options.topics;
		this.sortSubTopics = options.subTopics;
		this.sortSenders = options.senders;
		this.sortForms = options.forms;
		this.sortFilters();
	}
}
